exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".link-icons{background:#eff4f7;margin:10px auto}.link-group{display:flex;flex-wrap:wrap;justify-content:space-between;padding:0}.link-group .link-promotion{width:100px;height:160px;color:#475152;display:flex;padding:10px 0;flex-direction:column;align-items:center;justify-content:center}.link-group .link-promotion i{font-size:35px;padding:2px 15px}.link-group .link-promotion span{color:#475152;text-decoration:none;font-size:13px;font-weight:300;text-align:center;padding:0 15px}@media (min-width:961px){.link-group{min-height:151px;align-items:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/dist/cjs.js??ref--1-3!./components/link-icons/link-icons.scss
// module id = 560
// module chunks = 0